import { logEvent } from 'firebase/analytics';
import { analytics } from '../firebase-config.js';

// DOM Elements
const servicesDropdown = document.getElementById('services-dropdown');
const servicesDropdownTapTarget = document.getElementById('services-dropdown-tap-target');
const servicesDropdownScreenReaderText = document.getElementById('services-dropdown-screen-reader-text');
const servicesCat1 = document.getElementById('service-category-1');
const servicesCat2 = document.getElementById('service-category-2');
const servicesCat3 = document.getElementById('service-category-3');
const servicesCat4 = document.getElementById('service-category-4');
const servicesDropdownCaret = document.getElementById('services-dropdown-caret');
const servicesHighlighter1 = document.getElementById('services-highlighter-1');
const servicesHighlighter2 = document.getElementById('services-highlighter-2');
const servicesHighlighter3 = document.getElementById('services-highlighter-3');
const servicesHighlighter4 = document.getElementById('services-highlighter-4');
const servicesCatUl = document.querySelectorAll('.services-cat-ul');
const servicesCatBranding = document.getElementById('services-category-branding');
const servicesCatAppWeb = document.getElementById('services-category-app-web');
const servicesCatGraphics = document.getElementById('services-category-graphics');
const servicesCatOther = document.getElementById('services-category-other');

// State
var activeCategory = 'Branding';

// -- WINDOW RESIZE HANDLER ------------------------------------------------------ //

window.addEventListener('resize', SetCategoryLabelsAndCollapseMobileDropdown);

function SetCategoryLabelsAndCollapseMobileDropdown() {
    if (window.innerWidth < 768) {
        switch(activeCategory) {
            case 'Branding':
                servicesCat1.innerHTML = 'Branding';
                servicesCat2.innerHTML = 'App <span style="font-family: garamond-premier-pro-display, serif;">/</span> Web';
                servicesCat3.innerHTML = 'Graphics';
                servicesCat4.innerHTML = 'Other';
                break;
            case 'App / Web':
                servicesCat1.innerHTML = 'App <span style="font-family: garamond-premier-pro-display, serif;">/</span> Web';
                servicesCat2.innerHTML = 'Branding';
                servicesCat3.innerHTML = 'Graphics';
                servicesCat4.innerHTML = 'Other';
                break;
            case 'Graphics':
                servicesCat1.innerHTML = 'Graphics';
                servicesCat2.innerHTML = 'Branding';
                servicesCat3.innerHTML = 'App <span style="font-family: garamond-premier-pro-display, serif;">/</span> Web';
                servicesCat4.innerHTML = 'Other';
                break;
            case 'Other':
                servicesCat1.innerHTML = 'Other';
                servicesCat2.innerHTML = 'Branding';
                servicesCat3.innerHTML = 'App <span style="font-family: garamond-premier-pro-display, serif;">/</span> Web';
                servicesCat4.innerHTML = 'Graphics';
                break;
        }
    }

    if (window.innerWidth > 767) {
        // Reset inner HTML of category labels on tablet / desktop
        servicesCat1.innerHTML = 'Branding';
        servicesCat2.innerHTML = 'App <span style="font-family: garamond-premier-pro-display, serif;">/</span> Web';
        servicesCat3.innerHTML = 'Graphics';
        servicesCat4.innerHTML = 'Other';

        // Set the highlighter
        switch(activeCategory) {
            case 'Branding':
                servicesCat2.classList.remove('active');
                servicesCat3.classList.remove('active');
                servicesCat4.classList.remove('active');
                servicesCat1.classList.add('active');
                servicesHighlighter1.classList.add('active');
                servicesHighlighter2.classList.remove('active');
                servicesHighlighter3.classList.remove('active');
                servicesHighlighter4.classList.remove('active');
                break;

            case 'App / Web':
                servicesCat1.classList.remove('active');
                servicesCat3.classList.remove('active');
                servicesCat4.classList.remove('active');
                servicesCat2.classList.add('active');
                servicesHighlighter1.classList.remove('active');
                servicesHighlighter2.classList.add('active');
                servicesHighlighter3.classList.remove('active');
                servicesHighlighter4.classList.remove('active');
                break;

            case 'Graphics':
                servicesCat1.classList.remove('active');
                servicesCat2.classList.remove('active');
                servicesCat4.classList.remove('active');
                servicesCat3.classList.add('active');
                servicesHighlighter1.classList.remove('active');
                servicesHighlighter2.classList.remove('active');
                servicesHighlighter3.classList.add('active');
                servicesHighlighter4.classList.remove('active');
                break;

            case 'Other':
                servicesCat1.classList.remove('active');
                servicesCat2.classList.remove('active');
                servicesCat3.classList.remove('active');
                servicesCat4.classList.add('active');
                servicesHighlighter1.classList.remove('active');
                servicesHighlighter2.classList.remove('active');
                servicesHighlighter3.classList.remove('active');
                servicesHighlighter4.classList.add('active');
                break;
        }

        // Collapse mobile dropdown if open
        if (servicesDropdown.classList.contains('expanded')) {
            servicesDropdownScreenReaderText.setAttribute('aria-expanded', 'false');
            servicesDropdownScreenReaderText.textContent = "Click to open";
            servicesDropdown.classList.remove('expanded');
            servicesDropdownCaret.classList.remove('up');
        }
    }
}

// -- DROPDOWN TAP TARGET -------------------------------------------------------- //

servicesDropdownTapTarget.addEventListener('click', function () {
    if (window.innerWidth < 768) {
        ExpandCollapseDropdown();
    }
});

// -- SERVICE CATEGORY 1 CLICK HANDLER ------------------------------------------- //

servicesCat1.addEventListener('click', function () {
    if (window.innerWidth > 767) {
        if (activeCategory != 'Branding') {
            activeCategory = 'Branding';

            servicesCat1.innerHTML = 'Branding';
            servicesCat2.innerHTML = 'App <span style="font-family: garamond-premier-pro-display, serif;">/</span> Web';
            servicesCat3.innerHTML = 'Graphics';
            servicesCat4.innerHTML = 'Other';

            servicesCat2.classList.remove('active');
            servicesCat3.classList.remove('active');
            servicesCat4.classList.remove('active');
            servicesCat1.classList.add('active');

            servicesHighlighter1.classList.add('active');
            servicesHighlighter2.classList.remove('active');
            servicesHighlighter3.classList.remove('active');
            servicesHighlighter4.classList.remove('active');

            WaitToUpdateCategoryContent(activeCategory);
        }
        logEvent(analytics, 'desktop_services_cat_branding_clicked');
    }
});

// -- SERVICE CATEGORY 2 CLICK HANDLER ------------------------------------------- //

servicesCat2.addEventListener('click', function () {
    if (window.innerWidth < 768) {
        ExpandCollapseDropdown();

        if (activeCategory == 'Branding') {
            activeCategory = 'App / Web';
            logEvent(analytics, 'mobile_services_cat_app_web_clicked');
            servicesCat1.innerHTML = 'App <span style="font-family: garamond-premier-pro-display, serif;">/</span> Web';
            servicesCat2.innerHTML = 'Branding';
            servicesCat3.innerHTML = 'Graphics';
            servicesCat4.innerHTML = 'Other';
        } else if (activeCategory == 'App / Web') {
            activeCategory = 'Branding';
            logEvent(analytics, 'mobile_services_cat_branding_clicked');
            servicesCat1.innerHTML = 'Branding';
            servicesCat2.innerHTML = 'App <span style="font-family: garamond-premier-pro-display, serif;">/</span> Web';
            servicesCat3.innerHTML = 'Graphics';
            servicesCat4.innerHTML = 'Other';
        } else if (activeCategory == 'Graphics') {
            activeCategory = 'Branding';
            logEvent(analytics, 'mobile_services_cat_branding_clicked');
            servicesCat1.innerHTML = 'Branding';
            servicesCat2.innerHTML = 'App <span style="font-family: garamond-premier-pro-display, serif;">/</span> Web';
            servicesCat3.innerHTML = 'Graphics';
            servicesCat4.innerHTML = 'Other';
        } else if (activeCategory == 'Other') {
            activeCategory = 'Branding';
            servicesCat1.innerHTML = 'Branding';
            logEvent(analytics, 'mobile_services_cat_branding_clicked');
            servicesCat2.innerHTML = 'App <span style="font-family: garamond-premier-pro-display, serif;">/</span> Web';
            servicesCat3.innerHTML = 'Graphics';
            servicesCat4.innerHTML = 'Other';
        }

        WaitToUpdateCategoryContent(activeCategory);
    }

    if (window.innerWidth > 767) {
        if (activeCategory != 'App / Web') {
            activeCategory = 'App / Web';

            servicesCat1.innerHTML = 'Branding';
            servicesCat2.innerHTML = 'App <span style="font-family: garamond-premier-pro-display, serif;">/</span> Web';
            servicesCat3.innerHTML = 'Graphics';
            servicesCat4.innerHTML = 'Other';

            servicesCat1.classList.remove('active');
            servicesCat3.classList.remove('active');
            servicesCat4.classList.remove('active');
            servicesCat2.classList.add('active');

            servicesHighlighter1.classList.remove('active');
            servicesHighlighter2.classList.add('active');
            servicesHighlighter3.classList.remove('active');
            servicesHighlighter4.classList.remove('active');

            WaitToUpdateCategoryContent(activeCategory);
        }

        logEvent(analytics, 'desktop_services_cat_app_web_clicked');
    }
});

// -- SERVICE CATEGORY 3 CLICK HANDLER ------------------------------------------- //

servicesCat3.addEventListener('click', function () {
    if (window.innerWidth < 768) {
        ExpandCollapseDropdown();

        if (activeCategory == 'Branding') {
            activeCategory = 'Graphics';
            logEvent(analytics, 'mobile_services_cat_graphics_clicked');
            servicesCat1.innerHTML = 'Graphics';
            servicesCat2.innerHTML = 'Branding';
            servicesCat3.innerHTML = 'App <span style="font-family: garamond-premier-pro-display, serif;">/</span> Web';
            servicesCat4.innerHTML = 'Other';
        } else if (activeCategory == 'Graphics') {
            activeCategory = 'App / Web';
            logEvent(analytics, 'mobile_services_cat_app_web_clicked');
            servicesCat1.innerHTML = 'App <span style="font-family: garamond-premier-pro-display, serif;">/</span> Web';
            servicesCat2.innerHTML = 'Branding';
            servicesCat3.innerHTML = 'Graphics';
            servicesCat4.innerHTML = 'Other';
        } else if (activeCategory == 'App / Web') {
            activeCategory = 'Graphics';
            logEvent(analytics, 'mobile_services_cat_graphics_clicked');
            servicesCat1.innerHTML = 'Graphics';
            servicesCat2.innerHTML = 'Branding';
            servicesCat3.innerHTML = 'App <span style="font-family: garamond-premier-pro-display, serif;">/</span> Web';
            servicesCat4.innerHTML = 'Other';
        } else if (activeCategory == 'Other') {
            activeCategory = 'App / Web';
            logEvent(analytics, 'mobile_services_app_web_clicked');
            servicesCat1.innerHTML = 'App <span style="font-family: garamond-premier-pro-display, serif;">/</span> Web';
            servicesCat2.innerHTML = 'Branding';
            servicesCat3.innerHTML = 'Graphics';
            servicesCat4.innerHTML = 'Other';
        }

        WaitToUpdateCategoryContent(activeCategory);
    }

    if (window.innerWidth > 767) {
        if (activeCategory != 'Graphics') {
            activeCategory = 'Graphics';

            servicesCat1.innerHTML = 'Branding';
            servicesCat2.innerHTML = 'App <span style="font-family: garamond-premier-pro-display, serif;">/</span> Web';
            servicesCat3.innerHTML = 'Graphics';
            servicesCat4.innerHTML = 'Other';

            servicesCat1.classList.remove('active');
            servicesCat2.classList.remove('active');
            servicesCat4.classList.remove('active');
            servicesCat3.classList.add('active');

            servicesHighlighter1.classList.remove('active');
            servicesHighlighter2.classList.remove('active');
            servicesHighlighter3.classList.add('active');
            servicesHighlighter4.classList.remove('active');

            WaitToUpdateCategoryContent(activeCategory);
        }

        logEvent(analytics, 'desktop_services_cat_graphics_clicked');
    }
});

// -- SERVICE CATEGORY 4 CLICK HANDLER ------------------------------------------- //

servicesCat4.addEventListener('click', function () {
    if (window.innerWidth < 768) {
        ExpandCollapseDropdown();

        if (activeCategory == 'Branding') {
            activeCategory = 'Other';
            logEvent(analytics, 'mobile_services_other_clicked');
            servicesCat1.innerHTML = 'Other';
            servicesCat2.innerHTML = 'Branding';
            servicesCat3.innerHTML = 'App <span style="font-family: garamond-premier-pro-display, serif;">/</span> Web';
            servicesCat4.innerHTML = 'Graphics';
        } else if (activeCategory == 'App / Web') {
            activeCategory = 'Other';
            logEvent(analytics, 'mobile_services_other_clicked');
            servicesCat1.innerHTML = 'Other';
            servicesCat2.innerHTML = 'Branding';
            servicesCat3.innerHTML = 'App <span style="font-family: garamond-premier-pro-display, serif;">/</span> Web';
            servicesCat4.innerHTML = 'Graphics';
        } else if (activeCategory == 'Graphics') {
            activeCategory = 'Other';
            logEvent(analytics, 'mobile_services_other_clicked');
            servicesCat1.innerHTML = 'Other';
            servicesCat2.innerHTML = 'Branding';
            servicesCat3.innerHTML = 'App <span style="font-family: garamond-premier-pro-display, serif;">/</span> Web';
            servicesCat4.innerHTML = 'Graphics';
        } else if (activeCategory == 'Other') {
            activeCategory = 'Graphics';
            logEvent(analytics, 'mobile_graphics_clicked');
            servicesCat1.innerHTML = 'Graphics';
            servicesCat2.innerHTML = 'Branding';
            servicesCat3.innerHTML = 'App <span style="font-family: garamond-premier-pro-display, serif;">/</span> Web';
            servicesCat4.innerHTML = 'Other';
        }

        WaitToUpdateCategoryContent(activeCategory);
    }

    if (window.innerWidth > 767) {
        if (activeCategory != 'Other') {
            activeCategory = 'Other';

            servicesCat1.innerHTML = 'Branding';
            servicesCat2.innerHTML = 'App <span style="font-family: garamond-premier-pro-display, serif;">/</span> Web';
            servicesCat3.innerHTML = 'Graphics';
            servicesCat4.innerHTML = 'Other';

            servicesCat1.classList.remove('active');
            servicesCat2.classList.remove('active');
            servicesCat3.classList.remove('active');
            servicesCat4.classList.add('active');

            servicesHighlighter1.classList.remove('active');
            servicesHighlighter2.classList.remove('active');
            servicesHighlighter3.classList.remove('active');
            servicesHighlighter4.classList.add('active');

            WaitToUpdateCategoryContent(activeCategory);
        }

        logEvent(analytics, 'desktop_services_cat_other_clicked');
    }
});

// -- CATEGORY CONTENT UPDATE FUNCTIONS ------------------------------------------ //

function WaitToUpdateCategoryContent(category) {
    servicesCatUl.forEach((categorySection) => {
        // Fade out services
        categorySection.classList.add('fade-services-out');
        categorySection.classList.remove('fade-services-in');
    });

    // Wait to update category content
    setTimeout(function() { UpdateCategoryContent(category) }, 250);
}

function UpdateCategoryContent(category) {
    switch(category) {
        case "Branding":
            servicesCatBranding.classList.add('display');
            servicesCatAppWeb.classList.remove('display');
            servicesCatGraphics.classList.remove('display');
            servicesCatOther.classList.remove('display');
            break;

        case 'App / Web':
            servicesCatBranding.classList.remove('display');
            servicesCatAppWeb.classList.add('display');
            servicesCatGraphics.classList.remove('display');
            servicesCatOther.classList.remove('display');
            break;

        case "Graphics":
            servicesCatBranding.classList.remove('display');
            servicesCatAppWeb.classList.remove('display');
            servicesCatGraphics.classList.add('display');
            servicesCatOther.classList.remove('display');
            break;

        case "Other":
            servicesCatBranding.classList.remove('display');
            servicesCatAppWeb.classList.remove('display');
            servicesCatGraphics.classList.remove('display');
            servicesCatOther.classList.add('display');
            break;
    }

    servicesCatUl.forEach((categorySection) => {
        // Fade in services
        categorySection.classList.add('fade-services-in');
        categorySection.classList.remove('fade-services-out');
    });
}

function ExpandCollapseDropdown() {
    servicesDropdown.classList.toggle('expanded');
    servicesDropdownCaret.classList.toggle('up');

    if (servicesDropdownScreenReaderText.getAttribute('aria-expanded') == 'false') {
        servicesDropdownScreenReaderText.setAttribute('aria-expanded', 'true');
        servicesDropdownScreenReaderText.textContent = "Click to close";
    } else {
        servicesDropdownScreenReaderText.setAttribute('aria-expanded', 'false');
        servicesDropdownScreenReaderText.textContent = "Click to open";
    }
}
